import { Pagination } from './Pagination';
import styles from './styles.module.scss';

type PaginationProps = React.ComponentProps<typeof Pagination>;

type Props = {
  itemCount: number;
  totalCount: number;
  currentPage: PaginationProps['currentPage'];
  totalPage: PaginationProps['totalPage'];
  handleFirstPageButtonClick: PaginationProps['onClickFirstPage'];
  handleBackButtonClick: PaginationProps['onClickBackPage'];
  handleNextButtonClick: PaginationProps['onClickNextPage'];
  handleLastPageButtonClick: PaginationProps['onClickLastPage'];
};

export const TableFooterPresentation: React.FC<Props> = ({
  itemCount,
  totalCount,
  currentPage,
  totalPage,
  handleFirstPageButtonClick,
  handleBackButtonClick,
  handleNextButtonClick,
  handleLastPageButtonClick,
}) => (
  <div className={styles.TableFooter}>
    <div className={styles.TableFooter__PerPageRoot}>
      <span className={styles.TableFooter__PerPageRoot__PerPageText}>
        Show {itemCount} Records of {totalCount} Records
      </span>
    </div>
    <Pagination
      currentPage={currentPage}
      totalPage={totalPage}
      onClickFirstPage={handleFirstPageButtonClick}
      onClickBackPage={handleBackButtonClick}
      onClickNextPage={handleNextButtonClick}
      onClickLastPage={handleLastPageButtonClick}
    />
  </div>
);
